import { useCallback, useState } from "react";

const AUTH_THEME_KEY = "wembii-auth-theme";

export type AuthPageTheme = "dark" | "light";

function readStoredTheme(): AuthPageTheme {
  if (typeof window === "undefined") return "dark";
  return localStorage.getItem(AUTH_THEME_KEY) === "light" ? "light" : "dark";
}

export function useAuthPageTheme() {
  const [theme, setThemeState] = useState<AuthPageTheme>(readStoredTheme);

  const setTheme = useCallback((next: AuthPageTheme) => {
    setThemeState(next);
    localStorage.setItem(AUTH_THEME_KEY, next);
  }, []);

  const toggleTheme = useCallback(() => {
    setThemeState((prev) => {
      const next: AuthPageTheme = prev === "dark" ? "light" : "dark";
      localStorage.setItem(AUTH_THEME_KEY, next);
      return next;
    });
  }, []);

  return { theme, setTheme, toggleTheme };
}
